var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.result)?_c('div',[_c('img',{attrs:{"src":_vm.result}}),_c('Compute')],1):_c('p',[_vm._v("Processing...")]),(_vm.source)?_c('img',{attrs:{"src":_vm.source}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }